import React from 'react';
import Snavbar from '../components/JSX/Snavbar';
import Slider3 from '../components/JSX/Slider3';
import How from '../components/JSX/How';
import Approach from '../components/JSX/Approach';

import Footers from '../components/JSX/Footers';

const Services1 = () => (
  <>
    <Snavbar />
    <Slider3 />
    <How/>
    <Approach/>
    <Footers/>
  </>
);

export default Services1;